import { render, staticRenderFns } from "./DocumentFieldProgress.vue?vue&type=template&id=3df8b20d&scoped=true"
import script from "./DocumentFieldProgress.vue?vue&type=script&lang=js"
export * from "./DocumentFieldProgress.vue?vue&type=script&lang=js"
import style0 from "./DocumentFieldProgress.vue?vue&type=style&index=0&id=3df8b20d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df8b20d",
  null
  
)

export default component.exports